import GenderHelper from '@/Scripts/lib/helper/genderHelper.js';
import GenerateImageHelper from '@/Scripts/lib/helper/generateImageHelper.js';
import GetSizes from '@/Scripts/lib/helper/imageSizesHelper.js';
import ImageCollectorHelper from '@/Scripts/lib/helper/imageCollectorHelper.js';

export default {
  props: {
    productName: String,
    variant: Object,
    variantIndex: Number,
    gender: String,
    allVariants: Array,
    colorSliderVariants: Array,
    nativeSlider: Boolean,
    showPackShotToggler: Boolean,
    deactivateMobileSwipe: Boolean,
    fullScreen: Boolean,
    imageSettings: Object,
    href: String,
    invisibleNavBackground: Boolean,
    forcePackShot: Boolean,
    noLazyImage: Boolean,
    showControls: Boolean,
    cols: Array,
    pageType: String,
    ariaLabel: String,
    useLookImages: Boolean
  },

  data () {
    return {
      activeIndex: 0,
      packShotPaddingDefault: 18,
      fullScreenMode: false
    };
  },

  computed: {
    packShotPadding () {
      return this.imageSettings.packShotPaddingOverride || this.packShotPaddingDefault;
    },
    productVideo () {
      if (this.currentVariantImages && !this.imageSettings.hideVideo) {
        let videos = this.currentVariantImages.filter(i => i.Type && (i.Type.includes('Video') || i.Type.includes('look-v')));
        if (!videos.length && this.allVariants) {
          videos = this.allVariants.map(variant => this.findVideoForVariant(variant)).filter(v => v !== null);
        }
        if (videos && videos.length) {
          // allways show only one video
          return videos[0];
        }
      }
      return null;
    },
    packShotMode () {
      return this.viewToggler === 1;
    },
    videoMode () {
      return this.viewToggler === 2;
    },
    hasPackShots () {
      const p = this.variant.MoreImages.filter(i => i.Type.includes('Pack'));
      return p && p.length > 0;
    },
    hasVideo () {
      return this.productVideo !== null;
    },
    videoSlideActive () {
      return this.hasVideo && this.items && this.items.length && this.items[this.activeIndex] && this.items[this.activeIndex].type === 'VideoFile';
    },
    displayFemaleModels () {
      return GenderHelper.getGender() === 'women';
    },

    heightHolder () {
      const p = this.imageSettings && this.imageSettings.proportion ? 100 / this.imageSettings.proportion : 1;
      return {
        '--height': `${p}%`
      };
    },
    imageSizes () {
      if (this.cols) {
        return GetSizes(this.cols);
      }
      return GetSizes([{ cols: 1, breakPoint: 0 }, { cols: 2, breakPoint: 'MD' }, { cols: 1.85, breakPoint: 'LG' }]);
    },

    items () {
      if (!this.variant) {
        return [];
      }
      const imageList = [];
      let data = [];

      if (this.colorSliderVariants) {
        data = this.generateColorSlideData();
      } else {
        data = this.generateRegularSlideData();
      }
      data.forEach((item, index) => {
        if (item.Path) {
          // Video
          // if (item.Path.includes('?tusv2=true')) {
          //   item.Type = 'VideoFile';
          // }
          if (item.Type.includes('Video') || item.Type.includes('look-v')) {
            imageList.push({
              id: item.Path,
              src: GenerateImageHelper.generateVideo(item.Path),
              type: 'VideoFile',
              ratio: 3 / 4
            });
          } else {
            // Image
            const borderSize = this.imageSettings.initWidth * ((item.Type.includes('Pack') ? this.packShotPadding : 0) / 100);
            const width = this.imageSettings.initWidth;
            const lookGridSizes = index === 0 ? GetSizes([{ cols: 1, breakPoint: 0 }, { cols: 2, breakPoint: 'MD' }, { cols: 1.85, breakPoint: 'LG' }]) : GetSizes([{ cols: 1, breakPoint: 0 }, { cols: 2, breakPoint: 'MD' }, { cols: 3, breakPoint: 'LG' }]);
            // const titleFromType = item.Type ? item.Type.match(/[A-Z][a-z]+/g).join(' ') : '';
            const isLook = this.useLookImages && item.Type.includes('look');
            const isPackShot = this.useLookImages && item.Type.includes('Pack');
            if (isLook) {
              item.BackDrop = true;
              if (item.Center.length === 0) {
                // backup 3/4 center point i look image is missing centerpoint!
                item.Center.push({ AspectRatio: 0.75, TopLeftX: 0.125, TopLeftY: 0, BottomRightX: 0.875, BottomRightY: 1 });
              }
            }
            const focal = isLook
              ? ImageCollectorHelper.getFocalPoint(item, this.imageSettings.proportion)
              : null;
            imageList.push({
              src: GenerateImageHelper.generateFocal(item.Path,
                {
                  width: width,
                  height: (width / this.imageSettings.proportion),
                  bgcolor: this.imageSettings.bgColor,
                  border: borderSize,
                  focal: focal,
                  backDrop: isLook,
                  packShot: isPackShot
                }),
              srcset: GenerateImageHelper.generateSrcset(item.Path, focal, this.imageSettings.bgColor, this.imageSettings.proportion, item.Type.includes('Pack') ? this.packShotPadding : 0, isLook, isPackShot),
              sizes: !this.useLookImages || this.cols ? this.imageSizes : lookGridSizes,
              description: item.Title,
              class: '',
              type: item.Type,
              placeholder: isLook
                ? GenerateImageHelper.generateFocal('modelbackdrop/Background-1',
                  { width: width,
                    height: (width / this.imageSettings.proportion),
                    focal: focal,
                    bgcolor: this.imageSettings.bgColor }

                )
                : ''
            });
          }
        }
      });

      if (!imageList.length) {
        imageList.push(this.blankImage);
      }
      return imageList;
    },
    blankImage () {
      const width = this.imageSettings.initWidth;
      return {
        src: GenerateImageHelper.generateFocal(null,
          {
            width: width,
            height: (width / this.imageSettings.proportion),
            bgcolor: this.imageSettings.bgColor

          }),
        srcset: GenerateImageHelper.generateSrcset(null, false, this.imageSettings.bgColor, this.imageSettings.proportion),
        sizes: this.imageSizes
      };
    },
    displayedModelImages () {
      return this.viewMore ? this.items : this.items.slice(0, this.displayedModelImagesCount);
    },
    currentVariantImages () {
      return this.getVariantImage(this.variant);
    }

  },
  methods: {
    getVariantImage (variant) {
      if (this.useLookImages && variant.LookImages && variant.LookImages.length > 0) {
        const lookImages = !this.imageSettings.hideVideo ? variant.LookImages : variant.LookImages.filter(i => !i.Type.includes('look-v'));
        const packImages = !this.imageSettings.hidePackShots ? variant.MoreImages.filter(i => i.Type.includes('Pack')) : [];
        return [...lookImages, ...packImages];
      }
      return !this.imageSettings.hideModelShots ? this.variant.MoreImages : this.variant.MoreImages.filter(i => !i.Type.includes('Model'));
    },
    generateRegularSlideData () {
      const packImages = !this.imageSettings.hidePackShots ? this.currentVariantImages.filter(i => i.Type.includes('Pack')) : [];

      const menImages = !this.imageSettings.hideModelShots ? this.currentVariantImages.filter(i => !i.Type.includes('Women')) : [];
      const womenImages = !this.imageSettings.hideModelShots ? this.currentVariantImages.filter(i => i.Type.includes('Women')) : [];

      const currentVariantVideos = this.currentVariantImages.filter(i => i.Type.includes('Video') || i.Type.includes('look-v'));
      if (this.packShotMode || this.forcePackShot) {
        return packImages; // packshot-mode
      }
      // female first
      if (this.displayFemaleModels && womenImages.length) {
        if (currentVariantVideos.length === 0 && this.hasVideo) {
          return [...womenImages, ...menImages, this.productVideo]; // female first, with video from other color
        }
        return [...womenImages, ...menImages]; // female first
      }
      if (currentVariantVideos.length === 0 && this.hasVideo) {
        return [...this.variant.LookImages, this.productVideo, ...packImages];
      }
      return this.currentVariantImages; // standard view
    },
    generateColorSlideData () {
      if (this.packShotMode || this.forcePackShot) {
        return this.colorSliderVariants.map(variant => this.findPackshotForVariant(variant));
      }
      if (this.displayFemaleModels) {
        return this.colorSliderVariants.map(variant => this.findWomanForVariant(variant));
      }
      return this.colorSliderVariants.map(variant => this.findImageForVariant(variant));
    },
    findPackshotForVariant (variant) {
      const images = this.getVariantImage(variant);
      const filtered = images.filter(i => i.Type.includes('Pack'));
      if (filtered.length) { return filtered[0]; }
      if (variant.PackshotMain) { return { Path: variant.PackshotMain, Type: 'PackShot' }; }
      if (images.length) { return images[0]; }
      if (variant.ModelshotMain) { return { Path: variant.ModelshotMain, Type: 'ModelShot' }; }
      return { Path: '', Type: 'NotFound' };
    },
    findWomanForVariant (variant) {
      const filtered = this.getVariantImage(variant).filter(i => i.Type.includes('Women'));
      if (filtered.length) { return filtered[0]; }
      return this.findImageForVariant(variant);
    },
    findImageForVariant (variant) {
      const images = this.getVariantImage(variant);
      if (images.length) { return images[0]; }
      if (variant.ModelshotMain) { return { Path: variant.ModelshotMain, Type: 'ModelShot' }; }
      if (variant.PackshotMain) { return { Path: variant.PackshotMain, Type: 'PackShot' }; }
      return { Path: '', Type: 'NotFound' };
    },
    findVideoForVariant (variant) {
      const images = this.getVariantImage(variant);
      if (images) {
        const filtered = images.filter(i => i.Type && (i.Type.includes('Video') || i.Type.includes('look-v')));
        if (filtered.length) { return filtered[0]; }
      }
      return null;
    },
    imageHasSrc (obj) {
      return typeof obj.src !== 'undefined';
    },
    getGridColumn (index) {
      if (index === 0) return '1 / 3';
      return 'auto';
    },
    imageClick (index) {
      if (this.fullScreen) {
        this.activeIndex = index;
        this.fullScreenMode = true;
      }
    },
    toggleMoreImages () {
      this.viewMore = !this.viewMore;
    }
  }
};
